<template>
    <div class="md-layout">
        <div class="md-layout-item md-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="md-layout mt-4">
                        <div class="md-layout-item">
                            <multiselect v-model="queryKey" id="index" label="name" track-by="labourer_number"
                                         placeholder="Type to search" open-direction="bottom"
                                         :options="labourers" :multiple="false" :searchable="true" :loading="isLoading"
                                         :internal-search="false" :clear-on-select="true" :close-on-select="true"
                                         :options-limit="300" :max-height="600"
                                         :show-no-results="true" :hide-selected="false"
                                         @search-change="labourerSearch"
                                         @select="goSearch">
                                <span slot="noResult" v-if="queryKey.length>2">Oops! No elements found. Consider changing the search query.</span>
                            </multiselect>
                        </div>
                    </div>
                </md-card-header>
                <md-card-content v-if="labourer!==null">
                    <labourer-card :labourer="labourer"/>
                </md-card-content>
                <md-card-content v-else>
                    <h3 class="text-center">Search Labourer to View Take-ons Details</h3>
                </md-card-content>
            </md-card>
            <md-card v-if="labourer!==null">
                <md-card-content>
                    <LabourerTakeonCard :takeon="labourer.currentLabourerSchedule" title="Current Take on"/>
                    <LabourerTakeonCard :takeon="labourer.nextLabourerSchedule" title="Next Take on"/>
                </md-card-content>
            </md-card>
        </div>
    </div>
</template>
<script>
// import SelectInput from "../../../components/Inputs/SelectInput";
//
// import {
//     NavTabsCard,
//     AddParentModal,
//     AddSkillModal,
//     AddEducationModal
// } from "@/components";

// import GeneralTable from "../../../components/Tables/GeneralTable";


import Multiselect from 'vue-multiselect';
import LabourerCard from './LabourerCard';
import LabourerTakeonCard from './LabourerTakeonCard';

export default {
    components: { LabourerTakeonCard, LabourerCard,Multiselect },
    data () {
        return {
            isLoading: false,
            labourerIndex: 0,
            takeon: {},
            labourer: null,
            queryKey: '',
            labourers: [],
            image: '',
            file: null,
            default_image: process.env.VUE_APP_BASE_URL + '/img/placeholder.jpg',
            default_path: process.env.VUE_APP_BASE_URL,
        };
    },
    created () {
    },
    methods: {

        async get () {
            try {
                const id = this.$route.params.id;
                await this.$store.dispatch('labourers/get', id);
                this.labourer = this.$store.getters['labourers/labourer'];
                console.log(this.labourer);
            } catch (e) {
                await this.$store.dispatch(
                    'alerts/error',
                    'Oops, something went wrong!'
                );
            }
        },
        async labourerSearch (query) {
            console.log(query.length);
            if (query.length > 2) {
                this.isLoading = true;
                let params = {
                    include: 'currentLabourerSchedule.schedule,currentLabourerSchedule.workplace,currentLabourerSchedule.activity,currentLabourerSchedule.shift,nextLabourerSchedule.schedule,nextLabourerSchedule.workplace,nextLabourerSchedule.activity,nextLabourerSchedule.shift',
                    filter: {
                        queryKey: query
                    }
                };
                await this.$store.dispatch('labourers/list', params).then(() => {
                    this.labourers = this.$store.getters['labourers/list'];
                    this.isLoading = false;
                });
            }
        },
        async goSearch (value) {
            this.isLoading = false;
            this.labourer = value;
        },
        goToEdit (id) {
            this.$router.push({ name: 'Edit Labourer', params: { id } });
        },
        goToNext () {
            let index = this.labourerIndex + 1;
            if (this.labourers.length > index) {
                this.labourerIndex = index;
                this.labourer = this.labourers[index];
            }
        },
        goToPrevious () {
            if (this.labourerIndex > 0) {
                this.labourerIndex = this.labourerIndex - 1;
                this.labourer = this.labourers[this.labourerIndex];
            }
        },
        goToEditRow (name, item) {
            let id = item.id;
            this.$router.push({ name: name, params: { id } });
        },
        goToEditRowModal (name, item) {
            let id = item.id;
            this.$router.push({ name: name, params: { id } });
        },
        goBack () {
            this.$router.push({ name: 'Labourers List' });
        },

    }
};
</script>
<style lang="scss" scoped>

</style>
